module.exports = __webpack_public_path__ + "img/ide-aha.9ae68cc3.svg";